import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MastersRoutingModule } from "./masters-routing.module";
import { BranchMasterComponent } from "./branch-master/branch-master.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MaterialModule } from "app/material.module";
import { SharedModule } from "app/shared/shared.module";
import { WebcamModule } from "ngx-webcam";
import { SearchBranchMasterComponent } from "./search-branch-master/search-branch-master.component";
import { LocationMasterModule } from "./location-master/location-master.module";
import { SpecialIsAlphaNumericDirective } from "./special-is-alpha-numeric.directive";
import { ConfigurationModule } from "./configuration/configuration.module";
import { AccountMasterComponent } from "./Company-Setup/account-master/account-master.component";
import { SearchAccountMasterComponent } from "./Company-Setup/account-master/search-account-master/search-account-master.component";
import { MasterPanelComponent } from "./master-panel/master-panel.component";
// import { AccountTypeMasterComponent } from './company-setup/account-type-master/account-type-master.component';
// import { SearchAccountTypeMasterComponent } from './company-setup/account-type-master/search-account-type-master/search-account-type-master.component';
import { AccountTypeMasterComponent } from "./Company-Setup/account-type-master/account-type-master.component";
import { SearchAccountTypeMasterComponent } from "./Company-Setup/account-type-master/search-account-type-master/search-account-type-master.component";
import { AccountHeadMasterComponent } from "./Company-Setup/account-head-master/account-head-master.component";
import { SearchAccountHeadMasterComponent } from "./Company-Setup/account-head-master/search-account-head-master/search-account-head-master.component";
import { CompanyMasterComponent } from "./Company-Setup/company-master/company-master.component";
import { DashboardConfigurationComponent } from "./Company-Setup/company-master/dashboard-configuration/dashboard-configuration.component";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { SurgeryMasterComponent } from "./medical-record/sugery-master/surgery-master.component";
import { RoomCategoryMasterComponent } from "./billing-master/room-category-master/room-category-master.component";
import { RoomcategorymasterpipePipe } from "./billing-master/roomcategorymasterpipe.pipe";
import { OperationTheatreMasterComponent } from "./medical-record/operation-theatre-master/operation-theatre-master.component";
import { RateListMasterComponent } from "./billing-master/rate-list-master/rate-list-master.component";
import { PackageMasterComponent } from "./billing-master/package-master/package-master.component";
import { VoiceRecognitionService } from "./service/voice-recognition.service";
import { ConsentMasterComponent } from "./consent-master/consent-master.component";
import { CheckListMasterComponent } from "./checklist-master/checklist-master.component";
import { DiagnosisMasterComponent } from './diagnosis-master/diagnosis-master.component';
import { DiadnosissearchComponent } from './diagnosis-master/diadnosissearch/diadnosissearch.component';
import { OPDTestMasterComponent } from './opdtest-master/opdtest-master.component';
import { OPDTestMasterSearchComponent } from './opdtest-master/opdtest-master-search/opdtest-master-search.component';
import { CategorymasterComponent } from "./categorymaster/categorymaster.component";
import { SearchcategoryComponent } from "./categorymaster/searchcategory/searchcategory.component";
import { ExcelRateListComponent } from './billing-master/rate-list-master/excel-ratelist/excel-ratelist.component';
import { BillTypeMasterComponent } from './billing-master/bill-type-master/bill-type-master.component';
import { BillCategoryMasterComponent } from './billing-master/bill-category-master/bill-category-master.component';
import { PayTypeMasterComponent } from './billing-master/pay-type-master/pay-type-master.component';
import { DepositTypeMasterComponent } from './billing-master/deposit-type-master/deposit-type-master.component';
import { BillSeriesMasterComponent } from './billing-master/bill-series-master/bill-series-master.component';
import { DoctorAccountingModuleComponent } from './billing-master/doctor-accounting-module/doctor-accounting-module.component';
import { ComplaintCategoryMasterComponent } from './medical-record/complaint-category-master/complaint-category-master.component';
import { ComplaintMasterComponent } from './medical-record/complaint-master/complaint-master.component';
import { ReferredAccoutingModuleComponent } from './billing-master/referred-accouting-module/referred-accouting-module.component';
import { MedicineCatgeoryMasterComponent } from './medical-record/medicine-catgeory-master/medicine-catgeory-master.component';
import { MedicineMasterComponent } from './medical-record/medicine-master/medicine-master.component';
import { DosageMasterComponent } from './medical-record/dosage-master/dosage-master.component';
import { MedicineManufacturerMasterComponent } from './medical-record/medicine-manufacturer-master/medicine-manufacturer-master.component';
import { OperationTypeMasterComponent } from './medical-record/operation-type-master/operation-type-master.component';
import { ScheduleTypeMasterComponent } from './schedule-master/schedule-type-master/schedule-type-master.component';
import { OpdScheduleManagerComponent } from './schedule-master/opd-schedule-manager/opd-schedule-manager.component';
import { SurgicalScheduleMasterComponent } from './schedule-master/surgical-schedule-master/surgical-schedule-master.component';
import { ReportMasterComponent } from './report-master/report-master.component';


@NgModule({
  declarations: [
    BranchMasterComponent,
    SearchBranchMasterComponent,
    SpecialIsAlphaNumericDirective,
    AccountMasterComponent,
    SearchAccountMasterComponent,
    MasterPanelComponent,
    // AccountTypeMasterComponent,
    // SearchAccountTypeMasterComponent
    AccountTypeMasterComponent,
    SearchAccountTypeMasterComponent,
    AccountHeadMasterComponent,
    SearchAccountHeadMasterComponent,
    CompanyMasterComponent,
    DashboardConfigurationComponent,
    SurgeryMasterComponent,
    RoomCategoryMasterComponent,
    RateListMasterComponent,
    PackageMasterComponent,
    RoomcategorymasterpipePipe,
    OperationTheatreMasterComponent,
    ConsentMasterComponent,
    CheckListMasterComponent,
    DiagnosisMasterComponent,
    DiadnosissearchComponent,
    OPDTestMasterComponent,
    OPDTestMasterSearchComponent,
    CategorymasterComponent,
    SearchcategoryComponent,
    ExcelRateListComponent,
    BillTypeMasterComponent,
    BillCategoryMasterComponent,
    PayTypeMasterComponent,
    DepositTypeMasterComponent,
    BillSeriesMasterComponent,
    DoctorAccountingModuleComponent,
    ComplaintCategoryMasterComponent,
    ComplaintMasterComponent,
    ReferredAccoutingModuleComponent,
    MedicineCatgeoryMasterComponent,
    MedicineMasterComponent,
    DosageMasterComponent,
    MedicineManufacturerMasterComponent,
    OperationTypeMasterComponent,
    ScheduleTypeMasterComponent,
    OpdScheduleManagerComponent,
    SurgicalScheduleMasterComponent,
    ReportMasterComponent,
    
  ],
  imports: [
    WebcamModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    MatFormFieldModule,
    MastersRoutingModule,
    LocationMasterModule,
    ConfigurationModule,
    Ng2SearchPipeModule,
  ],
})
export class MastersModule {}
